var $a044fe91b85fe4de$exports = {};
$a044fe91b85fe4de$exports = {
    "info": `\u{4FE1}\u{606F}`,
    "negative": `\u{9519}\u{8BEF}`,
    "notice": `\u{8B66}\u{544A}`,
    "positive": `\u{6210}\u{529F}`
};


export {$a044fe91b85fe4de$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
